import React from 'react';
import {
  IconEnhanceBadge,
  IconPlay,
  IconPause,
} from '@spotify-internal/encore-web/core';
import { useField } from 'react-final-form';
import * as Styled from '../AudioScriptPlaybackCard.styled';

type ResultPlaybackCardProps = {
  minutesSinceGeneration: number;
  script: string;
  onPlayPause: () => void;
  audioUrl: string;
  isPlaying: boolean;
};

const ResultPlaybackCard = ({
  minutesSinceGeneration,
  script,
  onPlayPause,
  audioUrl,
  isPlaying,
}: ResultPlaybackCardProps) => {
  // Get AI voice value from form to determine colors
  const {
    input: { value: aiVoice },
  } = useField('aiVoice');

  return (
    <Styled.Container variant="highlight" selectedVoice={aiVoice}>
      <Styled.GeneratedAt selectedVoice={aiVoice}>
        <IconEnhanceBadge size="small" />
        {minutesSinceGeneration > 0 ? (
          <p>Generated {minutesSinceGeneration} minutes ago</p>
        ) : (
          <p>Generated just now</p>
        )}
      </Styled.GeneratedAt>
      <Styled.Content>
        <Styled.ScriptContainer selectedVoice={aiVoice}>
          <Styled.Script>{script}</Styled.Script>
        </Styled.ScriptContainer>
      </Styled.Content>
      <>
        <Styled.PlayButton
          onClick={onPlayPause}
          disabled={!audioUrl}
          selectedVoice={aiVoice}
        >
          {isPlaying ? <IconPause size="large" /> : <IconPlay size="large" />}
        </Styled.PlayButton>
      </>
    </Styled.Container>
  );
};

export default ResultPlaybackCard;
